/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetManyBaseAodRulesControllerAodRuleQueryResponse, GetManyBaseAodRulesControllerAodRuleQueryParams } from "../models/GetManyBaseAodRulesControllerAodRule";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getManyBaseAodRulesControllerAodRule } from "../axios/getManyBaseAodRulesControllerAodRule";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getManyBaseAodRulesControllerAodRuleQueryKey = (params: GetManyBaseAodRulesControllerAodRuleQueryParams = {}) => ["audit-reports-api", { url: '/aod-rules' }, ...(params ? [params] : [])] as const

export type GetManyBaseAodRulesControllerAodRuleQueryKey = ReturnType<typeof getManyBaseAodRulesControllerAodRuleQueryKey>

export function getManyBaseAodRulesControllerAodRuleQueryOptions(params?: GetManyBaseAodRulesControllerAodRuleQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getManyBaseAodRulesControllerAodRuleQueryKey(params)
        return queryOptions<GetManyBaseAodRulesControllerAodRuleQueryResponse, ResponseErrorConfig<Error>, GetManyBaseAodRulesControllerAodRuleQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getManyBaseAodRulesControllerAodRule(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve multiple AodRules
 * {@link /aod-rules}
 */
export function useGetManyBaseAodRulesControllerAodRule<TData = GetManyBaseAodRulesControllerAodRuleQueryResponse, TQueryData = GetManyBaseAodRulesControllerAodRuleQueryResponse, TQueryKey extends QueryKey = GetManyBaseAodRulesControllerAodRuleQueryKey>(params?: GetManyBaseAodRulesControllerAodRuleQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetManyBaseAodRulesControllerAodRuleQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getManyBaseAodRulesControllerAodRuleQueryKey(params)
         

         const query = useQuery({
          ...getManyBaseAodRulesControllerAodRuleQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}